import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a7f89e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "New Customer", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Contact Information", -1))
const _hoisted_8 = { class: "form-field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Full Name:", -1))
const _hoisted_10 = { class: "form-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Address:", -1))
const _hoisted_12 = { class: "form-field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "City:", -1))
const _hoisted_14 = { class: "form-field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "State/Province:", -1))
const _hoisted_16 = { class: "form-field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Zip:", -1))
const _hoisted_18 = { class: "form-field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Country:", -1))
const _hoisted_20 = { class: "form-field" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Phone:", -1))
const _hoisted_22 = { class: "form-field" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Cell Phone:", -1))
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "This customer agrees to receive text message communications from this facility", -1))
const _hoisted_26 = { class: "box" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Accounts & Access", -1))
const _hoisted_28 = { class: "form-field" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Email:", -1))
const _hoisted_30 = { class: "form-field" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Username:", -1))
const _hoisted_32 = { class: "form-field" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Password:", -1))
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "form-field" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Password Confirmation:", -1))
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "form-field" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Security question:", -1))
const _hoisted_40 = { class: "form-field" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Security answer:", -1))
const _hoisted_42 = { class: "form-field" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Disable customer login", -1))
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  key: 1,
  style: {"color":"green"}
}
const _hoisted_46 = {
  key: 0,
  class: "box"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Personal Information", -1))
const _hoisted_48 = { class: "form-field" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Drivers license number:", -1))
const _hoisted_50 = { class: "form-field" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "State/Province:", -1))
const _hoisted_52 = { class: "form-field" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Social Security Number:", -1))
const _hoisted_54 = { class: "form-field" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Employer Name:", -1))
const _hoisted_56 = { class: "form-field" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Employer Phone Number:", -1))
const _hoisted_58 = { class: "form-field" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Emergency contact:", -1))
const _hoisted_60 = { class: "form-field" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Emergency contact phone number:", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "How did the customer hear about Zion Call Management?", -1))
const _hoisted_63 = { class: "box" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Alternate Contact Information", -1))
const _hoisted_65 = { class: "form-field" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Contact:", -1))
const _hoisted_67 = { class: "form-field" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Address:", -1))
const _hoisted_69 = { class: "form-field" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "City:", -1))
const _hoisted_71 = { class: "form-field" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "State/Province:", -1))
const _hoisted_73 = { class: "form-field" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Zip:", -1))
const _hoisted_75 = { class: "form-field" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Phone:", -1))
const _hoisted_77 = { class: "form-field" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Email:", -1))
const _hoisted_79 = { class: "box" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Notes", -1))
const _hoisted_81 = { class: "form-field" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Late fee exempt?", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Select if you want to exempt the late fee for this customer. ", -1))
const _hoisted_84 = { class: "form-field" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Invoice Note:", -1))
const _hoisted_86 = { class: "form-field" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Notes:", -1))
const _hoisted_88 = { key: 1 }
const _hoisted_89 = {
  key: 2,
  class: "form-errors",
  role: "alert"
}
const _hoisted_90 = { class: "btn" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" Updating Customer ")
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" Creating Customer ")
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" Update Customer ")
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" Create Customer ")

import { useRouter } from "vue-router";
import { computed, ref } from "vue";
import BaseSpinner from "@/components/BaseSpinner.vue";

import api from "@virgodev/bazaar/functions/api";
// import { CustomerDataInterface } from "@/types/customers";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: String,
    default: null,
  },
  rental: {
    type: Boolean,
    required: false,
    default: false,
  },
  unitId: {
    type: String,
    default: null,
    required: false,
  },
  marketplaceId: {
    type: String,
    default: "available",
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const router = useRouter();
const userInfo = ref();
const errors = ref("");
const status = ref("loading");

const formSubmitting = ref(false);
const formErrors = ref<Record<string, string[]>>({});
// The server reports problems per field (and under non_field_errors). Show each
// message once — the same text often applies to more than one field, as with an
// email address that is already taken.
const formErrorMessages = computed(() => {
  const messages = Object.values(formErrors.value).flat();
  return [
    ...new Set(messages.filter((message) => typeof message === "string")),
  ];
});
const passwordResetSending = ref();
// const customer = ref<CustomerDataInterface>();
const formFields = ref({
  name: ref(null),
  address: ref(null),
  alternate_address: ref(null),
  alternate_city: ref(null),
  alternate_contact: ref(null),
  alternate_email: ref(null),
  alternate_phone: ref(null),
  alternate_state: ref(null),
  alternate_zip: ref(null),
  auction_on: ref(null),
  cell_phone: ref(null),
  charge_on_offset: ref(null),
  city: ref(null),
  country: ref(null),
  drivers_license_number: ref(null),
  drivers_license_state: ref(null),
  emergency_contact: ref(null),
  emergency_phone: ref(null),
  employer_name: ref(null),
  employer_phone: ref(null),
  gate_keypad_zone: ref(null),
  gate_security_level: ref(null),
  gate_time_zone: ref(null),
  invoice_note: ref(""),
  late_fee_exempt: ref(false),
  notes: ref(""),
  phone: ref(null),
  referred_by: ref(null),
  security_answer: ref(null),
  security_question: ref(null),
  social_security_number: ref(null),
  state: ref(null),
  tax_exempt: ref(false),
  user_id: ref(null),
  zip: ref(null),
  texting_consent: ref(true),
  marketplace_reservation_id: ref(),
  //in User creation
  email: ref(null),
  username: ref(null),
  password: ref(null),
  password_confirmation: ref(null),
  login_is_disabled: ref(null),
});



async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    formFields.value = response.body;
    if (response.body.texting_consent_status == "granted") {
      formFields.value.texting_consent = true;
    } else {
      formFields.value.texting_consent = false;
    }

    await getUserInfo();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  status.value = "loaded";
}
async function sendPasswordReset() {
  passwordResetSending.value = "sending";
  const response = await api({
    url: `password_resets/?user_id=${formFields.value.user_id}&facilityId=${props.facilityId}`,
    method: "POST",
  });

  if (response.status == 200) {
    passwordResetSending.value = "sent";
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getUserInfo() {
  errors.value = "";
  const response = await api({
    url: `users/?id=${formFields.value.user_id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    userInfo.value = response.body;
    formFields.value.login_is_disabled = userInfo.value.login_is_disabled;
    formFields.value.username = userInfo.value.username;
    formFields.value.email = userInfo.value.email;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function submitForm() {
  if (props.marketplaceId && props.marketplaceId != "available") {
    formFields.value.marketplace_reservation_id = props.marketplaceId;
  }
  const json = JSON.parse(JSON.stringify(formFields.value));
  if (!json.email) {
    delete json.email;
  }
  if (!json.username) {
    delete json.username;
  }
  if (!json.password) {
    delete json.password;
  }
  if (!json.password_confirmation) {
    delete json.password_confirmation;
  }
  delete json.photo_identification;

  if (json.texting_consent) {
    json.texting_consent = "granted";
  } else {
    json.texting_consent = "denied";
  }
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `customer/`;
  let method: "POST" | "PATCH" = "POST";

  if (props.customerId) {
    url += `${props.customerId}/`;
    method = "PATCH";
  }
  url += `?facilityId=${props.facilityId}`;
  const responseData = await api({
    url,
    method,
    json,
  });

  formSubmitting.value = false;
  if (responseData.status === 200) {
    if (props.marketplaceId && props.marketplaceId != "available") {
      router.push({
        name: "rental",
        params: {
          facilityId: props.facilityId,
          customerId: responseData.body.id,
          unitType: "null",
          unitId: props.unitId,
          unitStatus: "marketplace",
          reservationId: props.marketplaceId,
        },
      });
    } else if (props.rental == true) {
      router.push({
        name: "rental",
        params: {
          customerId: props.customerId,
          facilityId: props.facilityId,
          unitStatus: "available",
        },
      });
    } else if (props.customerId) {
      router.push({
        name: "customer_detail_ess",
        params: {
          id: props.customerId,
          facilityId: props.facilityId,
        },
      });
    } else if (props.unitId) {
      router.push({
        name: "rental",
        params: {
          facilityId: props.facilityId,
          customerId: responseData.body.id,
          unitType: "null",
          unitId: props.unitId,
          unitStatus: "available",
        },
      });
    } else {
      router.push({
        name: "customer_detail_ess",
        params: {
          id: responseData.body.id,
          facilityId: props.facilityId,
        },
      });
    }
  } else if (
    // api() returns ApiError | ApiSuccess, and only ApiSuccess carries a body —
    // ApiError means no response came back at all. "in" narrows the union;
    // comparing status does not, because ApiSuccess.status is a plain number.
    "body" in responseData &&
    responseData.body &&
    typeof responseData.body === "object"
  ) {
    // Any error the server explains — 400 validation, or a 406 passed back from
    // the storage provider — is worth showing. Falling through to the
    // connection message hid the real reason, such as a duplicate email.
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
if (props.customerId) {
  getCustomer();
} else {
  status.value = "loaded";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.customerId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", null, "Edit " + _toDisplayString(formFields.value.name), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)),
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 2,
          preset: "large"
        }))
      : (status.value === 'loaded')
        ? (_openBlock(), _createElementBlock("form", {
            key: 3,
            class: "large-width-centered",
            enctype: "multipart/form-data",
            onSubmit: _withModifiers(submitForm, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.name) = $event)),
                    type: "text",
                    required: ""
                  }, null, 512), [
                    [_vModelText, formFields.value.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.address) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.address]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.city) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.city]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFields.value.state) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.state]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formFields.value.zip) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.zip]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formFields.value.country) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.country]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formFields.value.phone) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formFields.value.cell_phone) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.cell_phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formFields.value.texting_consent) = $event)),
                    class: "form-check-input",
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, formFields.value.texting_consent]
                  ]),
                  _hoisted_25
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formFields.value.email) = $event)),
                    type: "text",
                    required: ""
                  }, null, 512), [
                    [_vModelText, formFields.value.email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formFields.value.username) = $event)),
                    type: "text",
                    required: ""
                  }, null, 512), [
                    [_vModelText, formFields.value.username]
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  (__props.customerId)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formFields.value.password) = $event)),
                        type: "password",
                        disabled: userInfo.value
                      }, null, 8, _hoisted_34)), [
                        [_vModelText, formFields.value.password]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formFields.value.password) = $event)),
                        type: "password",
                        required: ""
                      }, null, 512)), [
                        [_vModelText, formFields.value.password]
                      ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  (__props.customerId)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formFields.value.password_confirmation) = $event)),
                        type: "password",
                        disabled: userInfo.value
                      }, null, 8, _hoisted_37)), [
                        [_vModelText, formFields.value.password_confirmation]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formFields.value.password_confirmation) = $event)),
                        type: "password",
                        required: ""
                      }, null, 512)), [
                        [_vModelText, formFields.value.password_confirmation]
                      ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formFields.value.security_question) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.security_question]
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formFields.value.security_answer) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.security_answer]
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formFields.value.login_is_disabled) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, formFields.value.login_is_disabled]
                  ]),
                  _hoisted_43
                ]),
                (formFields.value.user_id)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "btn btn-text",
                      disabled: passwordResetSending.value == 'sending',
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (sendPasswordReset()))
                    }, " Send password reset ", 8, _hoisted_44))
                  : _createCommentVNode("", true),
                (passwordResetSending.value == 'sent')
                  ? (_openBlock(), _createElementBlock("small", _hoisted_45, "Password reset successfully sent"))
                  : _createCommentVNode("", true)
              ])
            ]),
            (__props.customerId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_48, [
                        _hoisted_49,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formFields.value.drivers_license_number) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.drivers_license_number]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formFields.value.state) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.state]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formFields.value.social_security_number) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.social_security_number]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formFields.value.employer_name) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.employer_name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formFields.value.employer_phone) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.employer_phone]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formFields.value.emergency_contact) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.emergency_contact]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formFields.value.emergency_phone) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.emergency_phone]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_62,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formFields.value.referred_by) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.referred_by]
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_63, [
              _hoisted_64,
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formFields.value.alternate_contact) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.alternate_contact]
                  ])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _hoisted_68,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((formFields.value.alternate_address) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.alternate_address]
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _hoisted_70,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((formFields.value.alternate_city) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.alternate_city]
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((formFields.value.alternate_state) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.alternate_state]
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _hoisted_74,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((formFields.value.alternate_zip) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.alternate_zip]
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _hoisted_76,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((formFields.value.alternate_phone) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.alternate_phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((formFields.value.alternate_email) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.alternate_email]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _hoisted_80,
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_81, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((formFields.value.late_fee_exempt) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, formFields.value.late_fee_exempt]
                  ]),
                  _hoisted_82,
                  _hoisted_83
                ]),
                _createElementVNode("div", _hoisted_84, [
                  _hoisted_85,
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((formFields.value.invoice_note) = $event))
                  }, null, 512), [
                    [_vModelText, formFields.value.invoice_note]
                  ])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _hoisted_87,
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((formFields.value.notes) = $event))
                  }, null, 512), [
                    [_vModelText, formFields.value.notes]
                  ])
                ])
              ])
            ]),
            (errors.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(errors.value), 1))
              : _createCommentVNode("", true),
            (_unref(formErrorMessages).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formErrorMessages), (message) => {
                    return (_openBlock(), _createElementBlock("p", { key: message }, _toDisplayString(message), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", _hoisted_90, [
              (formSubmitting.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (__props.customerId)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_91
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_92
                        ], 64))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (__props.customerId)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_93
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_94
                        ], 64))
                  ], 64))
            ])
          ], 40, _hoisted_5))
        : _createCommentVNode("", true)
  ], 64))
}
}

})